import React, { useMemo } from 'react';
import i18n               from 'i18next';
import { NavLink }        from 'react-router-dom';
import { reduxForm }      from 'redux-form';
import { useTranslation } from 'react-i18next';

import CallMeContactsList      from '../../call-me-contacts-list';
import CloseButton             from '../../buttons/CloseButton';
import RenderButton            from '../../buttons/base/RenderButton';
import { RenderCheckboxField } from '../../fields/redux/RenderCheckboxField';
import { RenderPhoneField }    from '../../fields/redux/RenderPhoneField';
import { RenderTextField }     from '../../fields/redux/RenderTextField';
import { RenderTimeField }     from '../../renderTime';

import { useCommon }       from '../../../providers/common';
import { useSiteSettings } from '../../../providers/siteSettings';
import { useSidebar }      from '../../../providers/sidebar';

const CallMeForm = (props) => {
  const {
          handleSubmit,
          submitForm,
        }               = props;
  const {
          t,
          i18n: { language },
        }               = useTranslation();
  const {
          data: {
                  WORKING_TIME,
                },
        }               = useSiteSettings();
  const { hideSidebar } = useSidebar();
  const { pages }       = useCommon();

  const agreementPageUrl = useMemo(() => {
    const page = pages.find(page => page.template === 'policy-personal-data');

    return `/${page.urlKey}`;
  }, [pages]);

  const createPersonalDataString = useMemo(() => {
    return (
      <>
        <span>{t('сlient_agreement')}</span>{' '}
        <NavLink to={agreementPageUrl} className={'personal_data_link'} onClick={hideSidebar}>
          {t('client_agreement_processingOfPersonalData')}
        </NavLink>
      </>);
  }, [language, agreementPageUrl]);

  return (
    <form
      name={'CallMeForm'}
      className={'CallMeForm'}
      noValidate={true}
      method={'post'}
      onSubmit={(event) => submitForm(event, handleSubmit)}
    >
      <RenderTextField
        autoComplete={'off'}
        placeholder={t('client_name')}
        name={'name'}
        required
      />
      <RenderPhoneField
        autoComplete={'off'}
        placeholder={t('client_phone')}
        name={'phone'}
      />

      <RenderTimeField
        name={'time'}
        label={t('client_time_to_call')}
        options={[
          {
            value: '5',
            label: t('client_call_for_five_minutes'),
          }, {
            value: '',
            label: t('client_call_for_other_time'),
          },
        ]}
      />

      <RenderCheckboxField
        autoComplete={'off'}
        label={createPersonalDataString}
        name={'processingPersonalData'}
      />

      <div className={'buttonsContainer'}>
        <CloseButton label={t('btn_cancel')} />

        <RenderButton
          className={'fill'}
          label={t('client_order_call')}
          type={'submit'}
        />
      </div>
      <p className={'required_fields'}>{t('client_required_fields')}</p>
      <p className={'call-time'}>
        <span>{t('client_contact_center_workTime')}</span>{' '}
        <span className={'working_time_highlighting'}>{WORKING_TIME.FROM} - {WORKING_TIME.TO}</span>
      </p>
      <CallMeContactsList />
    </form>);
};

export default reduxForm({
  form:         'CallMeForm',
  validate:     (values) => {

    const errors = {};
    if (!values.name) {
      errors.name = i18n.t('client_set_yourFirstName');
    }

    if (!values.processingPersonalData) {
      errors.processingPersonalData = i18n.t('validation_error_agreement_required');
    }

    if (!values.phone || values.phone.indexOf('_') > -1) {
      errors.phone = i18n.t('client_set_yourPhone');
    }

    return errors;
  },
  onSubmitFail: (errors, dispatch) => {
  },
})(CallMeForm);
